import styled from '@emotion/styled'

/**
 * 3단 layout — Header(flex 0) + FunnelMain(flex 1) 으로 viewport 정확히 채움.
 * step container 가 자체 column layout(스크롤 영역 + BottomBar 분리) 으로
 * BottomBar 와 ProgressBar 등 고정 영역이 같이 스크롤되지 않도록.
 */
export const FunnelLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
`

export const FunnelMain = styled.main`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`
